<script setup>
import { onMounted } from "vue";
import pageTitle, { setPageTitle } from "../../utils/pageTitle";
import InboundOrders from "../../components/InboundOrders.vue";

onMounted(() => {
  setPageTitle("Inbound Orders");
});

</script>

<template>
  <v-card-title>{{ pageTitle }}</v-card-title>
  <v-card-subtitle>Use this section to manage inboundOrders. </v-card-subtitle>
  <div id="orders-grid-wrapper">
    <InboundOrders />
  </div>
</template>

<style>
 #orders-grid-wrapper {
   height: 100%;
   padding-bottom: 110px;
 }
</style>